// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2Nmo3","content":"LoadingAlert_content__3yX1j"};